
import React, { createContext, useContext } from 'react';
import { User, Session } from '@supabase/supabase-js';

export interface AuthState {
  user: User | null;
  session: Session | null;
  loading: boolean;
  initialized: boolean;
  isLoggingOut: boolean;
}

export const AuthContext = createContext<AuthState>({
  user: null,
  session: null,
  loading: true,
  initialized: false,
  isLoggingOut: false,
});

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  // Remove expensive debug logging that was causing performance issues
  // Only log when there are actual auth state changes, not on every hook call
  
  return context;
};
